import PageContent from '../../components/PageContent';
import AuthorTable from './components/AuthorTable';
import { getAuthorList } from '../../api/Auhtor';
import {useState, useEffect, useMemo} from 'react';
import {Grid} from "antd";
import {AuthorList} from "./components/AuthorList";
import styled from "styled-components";
import BG from "../../assets/images/report-list-bg.png";

const {useBreakpoint} = Grid

const MobileWrapper = styled.div`
  background-image: url(${BG});
  background-repeat: no-repeat;
  padding-top: 20px;
  padding-bottom: 20px;
`

const Wrapper = styled.div`
  margin-bottom: 20px;
  overflow: hidden;
  padding: 0 30px;
  @media screen and (max-width: 768px) {
    /* padding: 0 10px; */
    padding-left: 10px;
    padding-right: 0;
  }
`;


const WhiteHat = () => {
  // 定义变量
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageOptions, setPageOptions] = useState({
    total: 0,
    currentPage: 1,
    perSize: 10,
  });
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const breakpoint = useBreakpoint();

    const isMobile = useMemo(() => {
        return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
    }, [breakpoint])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await getAuthorList({
          page: 1,
          pageSize: 10,
        });
        setPageOptions({
          ...pageOptions,
          total: data.total,
          currentPage: data.current_page,
          perSize: data.per_page,
        });

        data.list.forEach((item, index) => {
          item.index = index;
        });
        // for (let i = 0; i < data.list.length; i++) {
        //   data.list[i].key = i;
        // }
        setTableData(data.list);
      } catch (_error) {
        setError(_error);
        message.error(_error.message);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handlePageChange = (page, pageSize) => {
    setPageOptions({
      ...pageOptions,
      currentPage: page,
      pageSize,
    });
    setLoading(true);
    getAuthorList({
      page,
      pageSize,
    })
      .then(({ data }) => {
        // for (let i = 0; i < data.list.length; i++) {
        //   data.list[i].key = i;
        // }
        data.list.forEach((item, index) => {
          item.index = index;
        });
        setPageOptions({
          ...pageOptions,
          total: data.total,
          currentPage: data.current_page,
          perSize: data.per_page,
        });
        setTableData(data.list);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <PageContent>
        {
            isMobile ? (
                <MobileWrapper>
                  <AuthorList
                      data={tableData}
                      loading={loading}
                      pagination={{
                        showSizeChanger: false,
                        showQuickJumper: false,
                        // hideOnSinglePage: true,
                        total: pageOptions.total,
                        current: pageOptions.currentPage,
                        pageSize: pageOptions.perSize,
                        onChange: (page, pageSize) => {
                          handlePageChange(page, pageSize);
                        },
                      }}
                      currentPage={pageOptions.currentPage}
                  />
                </MobileWrapper>
            ) : (
                <Wrapper>
                  <AuthorTable
                      data={tableData}
                      loading={loading}
                      pagination={{
                        showSizeChanger: false,
                        showQuickJumper: false,
                        // hideOnSinglePage: true,
                        total: pageOptions.total,
                        current: pageOptions.currentPage,
                        pageSize: pageOptions.perSize,
                        onChange: (page, pageSize) => {
                          handlePageChange(page, pageSize);
                        },
                      }}
                      currentPage={pageOptions.currentPage}
                  />
                </Wrapper>
            )
        }
    </PageContent>
  );
};

export default WhiteHat;
